<template>
	<a-card :body-style="{padding: '24px 32px'}" :bordered="false">
		<a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
			<a-form-model-item>
				<company-search
					v-model="search.company"
					placeholder="请选择所属公司"
				/>
			</a-form-model-item>
			<a-form-model-item>
				<a-range-picker
					valueFormat="YYYY-MM-DD"
					v-model="searchRange"
				/>
			</a-form-model-item>
			<a-form-model-item>
				<a-button
					type="primary"
					html-type="submit"
					icon="search"
				>
					查询
				</a-button>
			</a-form-model-item>
		</a-form-model>
		<a-divider />
		<a-table
			:loading="loading"
			:columns="columns"
			:data-source="list"
			:scroll="{y: 500 }"
			:pagination="pager"
			@change="change">
			<span slot="recharge" slot-scope="text, record">
				<span>
					充值金额：{{ record.fee }}</br>
					赠送金额：{{ record.present }}</br>
					共计金额：{{ record.fee + record.present }}
				</span>
			</span>
			<span slot="user" slot-scope="text, record">
        <a-avatar :src="record.user.headimgurl" />
        <span style="margin-left: 10px">{{ record.user.nickname }}</span>
			</span>
			<span slot="orderNo" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">
            {{ record.orderNo }}
          </template>
	        {{ record.orderNo }}
        </a-tooltip>
			</span>
			<span slot="isPay" slot-scope="text, record">
				<a-tag color="#87d068" v-if="text">成功</a-tag>
				<a-tag color="#f50" v-else>失败</a-tag>
			</span>
		</a-table>
	</a-card>
</template>
<script>
import { partnerRecharge } from '@/api/financial';

export default {
  data() {
    return {
    	search: {},
		  list: [],
		  pager: {},
		  loading: false,
		  searchRange: [],
    };
  },
  created() {
  	this.getList();
  },
  computed: {
	  columns() {
	  	return [
		  {
			  title: '#',
			  dataIndex: 'index',
			  customRender: (text, row, index) => index + 1,
			  key: 'index',
			  width: '50px',
		  },
		  {
			  title: '公司',
			  dataIndex: 'company.name',
			  key: 'companyName',
		  },
		  {
			  title: '用户',
			  dataIndex: 'user.nickName',
			  key: 'nickName',
		    scopedSlots: { customRender: 'user' },
		  },
		  {
			  title: '订单号',
			  dataIndex: 'orderNo',
			  key: 'orderNo',
		    ellipsis: true,
		    scopedSlots: { customRender: 'orderNo' },
		  },
		  {
			  title: '充值金额',
			  dataIndex: 'fee',
		    width: 160,
		    scopedSlots: { customRender: 'recharge' },
			  key: 'fee',
		  },
		  {
			  title: '操作人',
			  dataIndex: 'operator',
			  key: 'operator',
		  },
		  {
			  title: '支付结果',
			  dataIndex: 'isPay',
			  key: 'isPay',
			  scopedSlots: { customRender: 'isPay' },
		  },
		  {
			  title: '支付时间',
			  dataIndex: 'ctime',
			  key: 'ctime',
		  },
	  ];
	  },
  },
  methods: {
  	async getList() {
  		this.loading = true;
  		const q = this.search;
  		q.start = this.searchRange[0];
  		q.end = this.searchRange[1];
  		const { data: { docs, pager } } = await partnerRecharge(q);
  		this.list = docs;
  		this.pager = {
		    ...pager,
		    showTotal: (total) => `共计 ${total} 条信息`,
		  };
	    this.loading = false;
	  },
	  change(pagination) {
		  this.search.page = pagination.current;
		  this.getList();
	  },
	  handleSearch() {
  		this.getList();
	  },
  },
};
</script>
<style lang="less">

</style>
